module.exports = __webpack_public_path__ + "media/melanosis coli.ab73235c.wav";